module.exports = __webpack_public_path__ + "img/setupesd-min.f2e25508.png";